<template>
  <main class="main">
    <transition name="journal-view">
      <v-container id="journal-view" fluid tag="section">
        <div class="search mt-n3 pb-3">
          <v-btn dark color="primary" @click="openDialog(0, '')">
            <v-icon>mdi-plus</v-icon>
          </v-btn>

          <v-menu
            ref="filterDateMenu"
            v-model="filterDateMenu"
            :close-on-content-click="false"
            offset-y
            min-width="340px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="ml-2" color="primary" v-bind="attrs" v-on="on">
                <v-icon left>mdi-calendar-range</v-icon>
                Filter Tanggal
              </v-btn>
            </template>
            <v-card class="pa-3">
              <v-menu
                ref="filterStartDateMenu"
                v-model="filterStartDateMenu"
                :close-on-content-click="false"
                :return-value.sync="filter.startDate"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    dense
                    label="Tanggal Awal"
                    placeholder="Masukkan Tanggal Awal"
                    readonly
                    clearable
                    v-bind="attrs"
                    v-on="on"
                    :value="startDateFormattedMomentjs"
                    @click:clear="filter.startDate = ''"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="filter.startDate"
                  locale="id-ID"
                  no-title
                  scrollable
                  @click:date="
                    $refs.filterStartDateMenu.save(filter.startDate)
                    filterStartDateMenu = false
                  "
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="filterStartDateMenu = false">Cancel</v-btn>
                  <v-btn text color="primary" @click="$refs.filterStartDateMenu.save(filter.startDate)"
                    >OK</v-btn
                  >
                </v-date-picker>
              </v-menu>

              <v-menu
                ref="filterEndDateMenu"
                v-model="filterEndDateMenu"
                :close-on-content-click="false"
                :return-value.sync="filter.endDate"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    dense
                    label="Tanggal Akhir"
                    placeholder="Masukkan Tanggal Akhir"
                    readonly
                    clearable
                    v-bind="attrs"
                    v-on="on"
                    :value="endDateFormattedMomentjs"
                    @click:clear="filter.endDate = ''"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="filter.endDate"
                  locale="id-ID"
                  no-title
                  scrollable
                  @click:date="
                    $refs.filterEndDateMenu.save(filter.endDate)
                    filterEndDateMenu = false
                  "
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="filterEndDateMenu = false">Cancel</v-btn>
                  <v-btn text color="primary" @click="$refs.filterEndDateMenu.save(filter.endDate)">OK</v-btn>
                </v-date-picker>
              </v-menu>

              <div class="d-flex justify-end">
                <v-btn text color="primary" @click="resetDateFilter">Reset</v-btn>
                <v-btn color="primary" @click="applyDateFilter">Terapkan</v-btn>
              </div>
            </v-card>
          </v-menu>

          <v-select
            v-model="filter.journalType"
            :items="journalTypeItems"
            item-text="text"
            item-value="value"
            label="Tipe Jurnal"
            class="ml-2 type-filter"
            dense
            hide-details
            @change="applyDateFilter"
          ></v-select>

          <v-spacer></v-spacer>
          <v-btn class="mx-2" @click="getAllJournal()" fab small color="primary">
            <v-icon> mdi-autorenew </v-icon>
          </v-btn>
          <v-text-field
            v-model="table.search"
            prepend-icon="mdi-magnify"
            class="input"
            label="Cari Jurnal..."
            single-line
            hide-details
          ></v-text-field>
        </div>

        <div class="datatable">
          <v-data-table
            :headers="table.headers"
            :items="journals"
            no-data-text="No data"
            hide-default-footer
            :loading="isLoading"
            :search="table.search"
            :custom-filter="customFilter"
            :page.sync="pagination.page"
            :items-per-page="pagination.rowsPerPage"
            item-key="name"
            class="elevation-1"
            dense
          >
            <template v-slot:[`item.actions`]="{ item }">
              <v-menu bottom origin="center center" transition="scale-transition">
                <template v-slot:activator="{ on: menu, attrs }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on: tooltip }">
                      <v-btn icon color="primary" dark v-bind="attrs" v-on="{ ...tooltip, ...menu }">
                        <v-icon dark> mdi-menu </v-icon>
                      </v-btn>
                    </template>
                    <span>Menu</span>
                  </v-tooltip>
                </template>
                <v-list dense>
                  <v-list-item @click="openDialog(0, item._id)">
                    <v-list-item-icon>
                      <v-sicon>mdi-pencil</v-sicon>
                    </v-list-item-icon>
                    <v-list-item-title>Detail Jurnal</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-data-table>
        </div>
        <div class="datatable-action">
          <v-pagination
            v-model="pagination.page"
            :length="journalsPage"
            :total-visible="5"
            @input="getAllJournal()"
          ></v-pagination>
        </div>
      </v-container>
    </transition>
    <v-dialog v-model="isDialog" fullscreen>
      <journal-input
        v-if="selectedForm == 0"
        :id_journal="selectedItem"
        @change-form="changeForm"
        @close-form="closeForm"
      />
    </v-dialog>
  </main>
</template>

<script>
import Constant from '@/const'

import ConstantMixin from '@/constantMixin'
import JournalInput from '../components/accounting/JournalInput.vue'

const _ = require('lodash')
const moment = require('moment')
const axios = require('axios')

export default {
  name: 'Journal',
  components: { JournalInput },
  mixins: [ConstantMixin],
  data() {
    return {
      isLoading: false,
      isDialog: false,
      filterDateMenu: false,
      filterStartDateMenu: false,
      filterEndDateMenu: false,

      selectedForm: '',
      selectedItem: null,
      filter: {
        startDate: '',
        endDate: '',
        journalType: ''
      },
      journalTypeItems: [
        { text: 'Semua', value: '' },
        { text: 'Umum', value: 'general' },
        { text: 'Penyesuaian', value: 'adjustment' },
        { text: 'Otomatis', value: 'auto' }
      ],
      table: {
        search: '',
        headers: [
          {
            text: 'Jurnal',
            value: 'code',
            width: '150px',
            sortable: false,
            class: 'text-subtitle-1 font-weight-black'
          },
          {
            text: 'Tanggal',
            value: 'journal_date',
            width: '150px',
            sortable: false,
            class: 'text-subtitle-1 font-weight-black'
          },
          {
            text: 'Jam',
            value: 'journal_time',
            width: '80px',
            sortable: false,
            class: 'text-subtitle-1 font-weight-black'
          },
          {
            text: 'Deskripsi',
            value: 'description',
            sortable: false,
            class: 'text-subtitle-1 font-weight-black'
          },
          {
            text: 'Nominal',
            value: 'nominal',
            width: '90px',
            sortable: false,
            class: 'text-subtitle-1 font-weight-black'
          },
          {
            text: 'Status',
            value: 'status',
            width: '80px',
            sortable: false,
            align: 'center',
            class: 'text-subtitle-1 font-weight-black'
          },
          {
            text: '',
            align: 'center',
            value: 'actions',
            width: '50px',
            sortable: false,
            class: 'text-subtitle-1 font-weight-black'
          }
        ]
      }
    }
  },
  watch: {
    isDialog(newValue) {
      if (!newValue) {
        this.selectedForm = null
      }
    },
    'table.search'(val) {
      this.pagination.page = 1
      setTimeout(() => this.getAllJournal(), 300)
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.getAllJournal()
    })
  },
  computed: {
    startDateFormattedMomentjs() {
      return this.filter.startDate
        ? moment(this.filter.startDate)
            .locale('id')
            .format('D MMMM YYYY')
        : ''
    },
    endDateFormattedMomentjs() {
      return this.filter.endDate
        ? moment(this.filter.endDate)
            .locale('id')
            .format('D MMMM YYYY')
        : ''
    }
  },
  methods: {
    applyDateFilter() {
      this.pagination.page = 1
      this.filterDateMenu = false
      this.getAllJournal()
    },
    resetDateFilter() {
      this.filter.startDate = ''
      this.filter.endDate = ''
      this.filter.journalType = ''
      this.pagination.page = 1
      this.filterDateMenu = false
      this.getAllJournal()
    },
    getAllJournal(option) {
      try {
        this.isLoading = true
        this.runApiCalls(() => {
          axios
            .get(
              Constant.apiUrl.concat(
                '/accounting/journal?page=',
                this.pagination.page,
                '&itemCount=',
                this.pagination.rowsPerPage,
                '&search=',
                this.table.search,
                this.filter.startDate
                  ? `&startDate=${moment(this.filter.startDate).format('YYYY-MM-DD')}`
                  : '',
                this.filter.endDate ? `&endDate=${moment(this.filter.endDate).format('YYYY-MM-DD')}` : '',
                this.filter.journalType ? `&journalType=${this.filter.journalType}` : ''
              )
            )
            .then(response => {
              if (response.status == 200) {
                const { data, length } = response.data
                this.journalsPage = Math.ceil(length / this.pagination.rowsPerPage)
                this.journals = data.map(j => {
                  return {
                    ...j,
                    journal_date: moment(j.journal_date)
                      .locale('id')
                      .format('DD MMMM YYYY'),
                    journal_time: moment(j.journal_date)
                      .locale('id')
                      .format('HH:mm'),
                    nominal: this.getCurrency(j.nominal),
                    status: j.status.toUpperCase()
                  }
                })
              } else {
                this.journals = []
                this.journalsPage = 0
              }
              this.isLoading = false
            })
            .catch(error => {
              this.journals = []
              this.journalsPage = 0
              this.isLoading = false
              // console.log(error)
            })
        })
      } catch {
        this.isLoading = false
      }
    },
    deleteJournal(id_journal) {},
    openDialog(index, id_journal) {
      this.selectedItem = id_journal
      switch (index) {
        default:
          this.changeForm(index)
          break
      }
      this.isDialog = true
    },
    changeForm(item) {
      this.selectedForm = item
    },
    closeForm() {
      this.isDialog = false
      this.getAllJournal()
    },
    customFilter(value, search, item) {
      if (!search) return true

      const searchLower = search.toLowerCase()

      // Search across all relevant fields
      const searchableText = [item.code, item.description, item.journal_date, item.journal_time, item.status]
        .filter(Boolean)
        .join(' ')
        .toLowerCase()

      return searchableText.includes(searchLower)
    }
  }
}
</script>

<style lang="scss" scoped>
.search {
  display: flex;
  position: relative;
  align-items: center;
  justify-content: flex-end;
  right: 0;
}
.input {
  max-width: 30%;
}
.type-filter {
  max-width: 150px;
}
.datatable {
  height: 500px;
}
.main {
  width: 100%;
  flex-direction: column;
  position: relative;
  height: 95%;

  width: 90%;
  overflow-y: off;
  margin: 10px auto;
}
.datatable-action {
  position: absolute;
  left: 10px;
  bottom: -8vh;
}
.btn-new {
  right: 50px;
  bottom: 1vh;
}
</style>
